import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";

const DataTableTransfertsEntreComptePlusInfo = ({ data, title }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const { SearchBar } = Search;




  // Table columns
  const columns = [
    {
      dataField: "ref",
      text: "Référence",
      headerAlign: "center",
      headerStyle: { width: "10%" },
    },
    {
      dataField: "name",
      text: "Nom",
      headerAlign: "center",
    },
    {
      dataField: "year",
      text: "Année",
      headerAlign: "center",
      sort: true, // Activer le tri pour la colonne Année de Date
    },
    {
      dataField: "date",
      text: "Date",
      headerAlign: "center",
      sort: true, // Activer le tri pour la colonne Année de Date
    },
    {
      dataField: "sourceBanqueAccount",
      text: "Source",
      headerAlign: "center",
      formatter: (cell) => `${cell.bankAccountNumber} - ${cell.name}`
    },
    {
      dataField: "destinationBanqueAccount",
      text: "Destination",
      headerAlign: "center",
      formatter: (cell) => `${cell.bankAccountNumber} - ${cell.name}`
    },
    {
      dataField: "amount",
      text: "Montant",
      headerAlign: "center",
      formatter: (cell) => `${cell.toFixed(2)}`,
      align: "center", // Aligner les montants à droite pour une meilleure lisibilité
    }
  ];


  return (
    <div className="card card-dark">
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        {/* {stateDocument()} */}
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="ref"
          data={data}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <BootstrapTable
                {...props.baseProps}
                striped
                hover
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>

  );
};

export default DataTableTransfertsEntreComptePlusInfo;
